import { render, staticRenderFns } from "./processLayout.vue?vue&type=template&id=33852f89&scoped=true"
import script from "./processLayout.vue?vue&type=script&lang=js"
export * from "./processLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33852f89",
  null
  
)

export default component.exports